import React, { PureComponent } from 'react';
import TransformingSmallListCard from 'appSrc/components/List/TransformingSmallCard';
import style from './styles/style.module.css';

class TransformingListSeries extends PureComponent {
    render() {
        return (
            <div className={ style.transformingSeries }>
                { this.props.series.map( ( list ) => {
                    return (
                        <div className={ `${ style.cardWrapper } ${ this.props.className }`.trim() } key={ this.props.keyCode + list.listid }>
                            <TransformingSmallListCard list={ list } />
                        </div>
                    );
                } ) }
            </div>
        );
    }
}
TransformingListSeries.defaultProps = {
    series: [],
    keyCode: '',
    className: '',
};

export default TransformingListSeries;
